const p = (n, o) => {
  const e = n.__vccOpts || n;
  for (const [c, a] of o)
    e[c] = a;
  return e;
};
function s() {
  function n(e) {
    return e = e.replaceAll(/&lt;/g, "<"), e = e.replaceAll(/&gt;/g, ">"), e = e.replaceAll(/&quot;/g, '"'), e = e.replaceAll(/&#38;/g, "'"), e = e.replaceAll(/&#39;/g, "'"), e = e.replaceAll(/&amp;/g, "&"), e;
  }
  function o(e) {
    for (const c of Object.keys(e))
      typeof e[c] == "string" ? e[c] = n(e[c]) : typeof e[c] == "object" && o(e[c]);
  }
  return o(window.omikuji.t), { t: window.omikuji.t };
}
export {
  p as _,
  s as u
};
